<style lang="stylus" scoped>
@import './daphne/components/monthly.styl';
/*.mark {*/
/*  position: fixed;*/
/*  top: 0;*/
/*  left: 0;*/
/*  right: 0;*/
/*  bottom: 0;*/
/*  display: flex;*/
/*  background: rgba(0, 0, 0, 0.7);*/
/*  z-index: 100;*/

/*  .circle {*/
/*    margin: auto;*/
/*  }*/
//}
</style>
<template>
  <div>
    <div class="mark" v-show="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <el-dialog :visible.sync="mouthShow" title="请选择您需要导出数据的月份" class="el-allData">
      <el-row class="el-year">
        <el-col :span="1" @click.native="preYear">
          <i class="el-icon-arrow-left"></i>
        </el-col>
        <el-col :span="22" class="export-title">{{ selecedYear }}</el-col>
        <el-col :span="1" @click.native="nextYear">
          <i class="el-icon-arrow-right"></i>
        </el-col>
      </el-row>
      <el-row class="el-btn-m">
        <el-checkbox-group v-model="checkList">
          <el-col :span="6" v-for="item in mouthData" :key="item.key">
            <el-checkbox
                :label="item.key"
                :disabled="item.isDisabled"
                @change="changeCheck(item)"
            >{{ item.name }}
            </el-checkbox>
          </el-col>
        </el-checkbox-group>
      </el-row>
      <el-row class="more-export">
        <el-col :span="12">
          <el-button @click="hideExport">取消</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="confirmExport">确认导出</el-button>
        </el-col>
      </el-row>
    </el-dialog>

  </div>
</template>
<script>
import https from '@/api/freight.js'
import http from '@/api/cardData'
import Cookies from 'js-cookie'

var now = new Date()
now.setMonth(now.getMonth() - 1)
export default {
  props: {
    moduleName: {
      type: String,
      default: ''
    },
    provinceName: {
      type: String
    },
    provinCode: {
      type: String
    },
    pathwayCityCode: {
      type: String
    },
    cityName: {
      type: String
    },
    tab: {
      type: Number
    },
    oilBrand: {
      type: String
    },
    condition: {
      type: String
    },
    roadCode: {
      type: String
    },
    moduleType: {
      type: String
    },
    formData:{
      type:Object
    },
    toExportDetail: {
      type: [Function, String],
      default: ''
    }
  },
  data() {
    return {
      checkList: [],
      progressNum: 0, //进度条进度
      mark: false, //是否显示遮罩层
      mouthShow: true,
      monTime: now,
      mouthData: [],
      mouthAll: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月'
      ],
      selecedYear: '',
      tempChooseArr: []
    }
  },
  mounted() {
  },
  created() {
    this.showAddTow = true
    this.getendMonth()
  },
  beforeDestroy() {
  },
  computed: {
    allTab: function () {
      return this.$store.state.app.tab
    }
  },
  methods: {
    getendMonth() {
      let that = this
      let time = that.monTime
      let year = time.getFullYear()
      this.selecedYear = year
      this.initMonthData()
    },
    hideExport() {
      this.$emit('hideExport')
    },
    returnTime(tempChooseArr) {
      var yearMonths = ''
      for (var v of tempChooseArr) {
        let mouthArr = v.mouthArr
        for (var val of mouthArr) {
          yearMonths += v.yearName + val + ','
        }
      }
      yearMonths = yearMonths.substring(0, yearMonths.lastIndexOf(','))
      return yearMonths
    },
    //导出
    confirmExport() {
      let that = this
      let tempChooseArr = this.tempChooseArr
      if (tempChooseArr.length == 0) {
        this.$message({
          message: '至少要选择一个月份!!',
          type: 'warning'
        })
        return
      }
      this.mouthShow = false

        that.mark = true
        let reqId = Cookies.get('user')
        let moduleName = this.moduleName
        var yearMonths = ''
        for (var v of tempChooseArr) {
          let mouthArr = v.mouthArr
          for (var val of mouthArr) {
            yearMonths += v.yearName + '-' + val + ','
          }
        }
        yearMonths = yearMonths.substring(0, yearMonths.lastIndexOf(','))
        window.times = setInterval(function() {
          http[that.allTab].progress({ reqId }).then(e => {
            that.progressNum = e.data.percent
            if (e.data.percent >= 100) {
              that.mark = false
              that.$emit('hideExport')
              that.progressNum = 0
              clearInterval(window.times)
            }
          })
        }, 100)
        reqId += new Date() * 1

        // 传入函数进行执行
        if (that.toExportDetail) {
          that.toExportDetail(yearMonths, reqId)
          return
        }

        //  入网车辆吨位，运营车辆吨位，里程，运营时间 城市  导出
        if (moduleName == 'vehicleCountCity') {
          var province = that.provinceName
          var provinCode = that.provinCode
          var condition = that.condition
          window.location.assign(
              https.exportMoreData({
                yearMonths,
                reqId,
                province,
                provinCode,
                condition
              })
          )
        }
        // 重点道路运营: operateCollectionStat
        if (['operateCollectionStat_provincial'].includes(moduleName)) {
          var type = this.tab + 1
          window.location.assign(
              https.carOperateDown({
                countTime: yearMonths,
                reqId,
                type,
                moduleType: that.moduleType
              })
          )
        }
        if (['operateCollectionStat', 'operateCollectionStat_national'].includes(moduleName)) {
          // var type = this.tab + 1
          console.log(this.tab)
          console.log(moduleName)
          console.log(this.formData)
          if (this.tab == 0) {
            window.location.assign(
                https.operateStatisticsExport({
                  countTime: yearMonths,
                  roadType: 'operateCollectionStat' == moduleName ? 1 : 2,
                  reqId,
                  moduleType: that.moduleType,
                  ...this.formData
                })
            )
          }
          if (this.tab == 1) {
            window.location.assign(
                https.addEnergyExport({
                  countTime: yearMonths,
                  roadType: 'operateCollectionStat' == moduleName ? 1 : 2,
                  reqId,
                  moduleType: that.moduleType,
                  ...this.formData
                })
            )
          }
          if (this.tab == 2) {
            window.location.assign(
                https.addEnergyStopInfoExport({
                  countTime: yearMonths,
                  roadType: 'operateCollectionStat' == moduleName ? 1 : 2,
                  reqId,
                  moduleType: that.moduleType,
                  ...this.formData
                })
            )
          }
        }
        //  加油站停靠统计: oilCollectionStat
        if (moduleName == 'oilCollectionStat') {
          yearMonths = that.returnTime(tempChooseArr)
          let provinceName = that.provinceName
          let cityName = that.cityName
          let kind = that.oilBrand
          window.location.assign(
              https.carGasDowns({
                yearMonths,
                reqId,
                provinceName
              })
          )
        }
        //  途经各省品牌加油站停靠次数: pathwayProvinceOil
        if (moduleName == 'pathwayProvinceOil') {
          yearMonths = that.returnTime(tempChooseArr)
          window.location.assign(
              https.vehiclStationExprot({
                yearMonths,
                reqId
              })
          )
        }
        //  途经各市品牌加油站停靠次数: pathwayCityOil
        if (moduleName == 'pathwayCityOil') {
          // yearMonths = that.returnTime(tempChooseArr)
          var pathwayProvcode = that.provinCode
          window.location.assign(
              https.exportCityExport({
                yearMonths,
                reqId,
                pathwayProvcode
              })
          )
        }
        //  物流园停靠统计: wuliuCollectionStat
        if (moduleName == 'wuliuCollectionStat') {
          window.location.assign(
              https.carLogisDown({
                countTime: yearMonths,
                provinceName: that.provinceName,
                cityName: that.cityName,
                reqId
              })
          )
        }

        // a)	运营吨位分布批量导出
        if (moduleName == 'operatorTonVehicle') {
          window.location.assign(
              https.operatorVehicleExport({
                yearMonths: yearMonths,
                reqId
              })
          )
        }
        // a)	运营吨位分布批量导出
        if (moduleName == 'registerTonVehicle') {
          window.location.assign(
              https.carTonnageExport({
                yearMonths: yearMonths,
                reqId
              })
          )
        }
        // b)	运营里程分布批量导出
        if (moduleName == 'operatorMileageVehicle') {
          window.location.assign(
              https.operatorMileageExport({
                yearMonths: yearMonths,
                reqId
              })
          )
        }
        // c)	运营时间分布批量导出
        if (moduleName == 'operatorTimeVehicle') {
          window.location.assign(
              https.operatorTimeExport({
                yearMonths: yearMonths,
                reqId
              })
          )
        }
        // c)	途经各省运营车次统计
        if (moduleName == 'vehicleWayCount') {
          window.location.assign(
              https.carTrainsDown({
                time: yearMonths,
                reqId
              })
          )
        }
        // 途经道路里程情况统计: wayRoadType
        if (moduleName == 'wayRoadType') {
          var type = that.tab
          window.location.assign(
              https.wayRoadExport({
                reqId,
                yearMonths,
                type
              })
          )
        }
        // 月均加油站停靠占比统计: vehiclePoiStopRadio
        if (moduleName == 'vehiclePoiStopRadio') {
          window.location.assign(
              https.stopProvinceStationExport({
                yearMonths: yearMonths,
                reqId
              })
          )
        }

    },
    initMonthData() {
      var that = this
      this.checkList = []
      this.mouthData = []
      let selecedYear = this.selecedYear
      console.log('123123')
      // operateCollectionStat_provincial
      if (['operateCollectionStat', 'operateCollectionStat_national'].includes(this.moduleName)) {
        https
            .exportFreightDiscern3({
              year: selecedYear,
              roadType: 'operateCollectionStat' == this.moduleName ? 1 : 2,
              dimension: this.tab == 2 ? '1' : '',
            })
            .then(e => {
              let data = e.data
              let str = 'ok'
              var mouthData = []
              let mouthAll = this.mouthAll
              for (var i = 0; i < data.length; i++) {
                if (data[i].indexOf(str) != -1) {
                  mouthData.push({
                    name: mouthAll[i],
                    isDisabled: false,
                    key: data[i].slice(0, -2),
                    isClick: false
                  })
                } else {
                  mouthData.push({
                    name: mouthAll[i],
                    isDisabled: true,
                    key: data[i],
                    isClick: true
                  })
                }
              }
              this.mouthData = mouthData
              this.isCheckMore()
              let tempChooseArr = this.tempChooseArr
              let selecedYear = this.selecedYear
              for (var v of tempChooseArr) {
                if (v.yearName == selecedYear) {
                  this.checkList = v.mouthArr
                }
              }
            })
      } else {
        https
            .exportFreightDiscern2({
              year: selecedYear,
              moduleName: that.moduleName,
              provinceCode: that.provinCode ? that.provinCode : '',
              provinceName: that.provinceName ? that.provinceName : '',
              region: that.cityName ? that.cityName : '',
              oilBrand: that.oilBrand ? that.oilBrand : '',
              pathwayCityCode: that.pathwayCityCode ? that.pathwayCityCode : '',
              roadCode: that.roadCode ? that.roadCode : '',
            })
            .then(e => {
              let data = e.data
              let str = 'ok'
              var mouthData = []
              let mouthAll = this.mouthAll
              for (var i = 0; i < data.length; i++) {
                if (data[i].indexOf(str) != -1) {
                  mouthData.push({
                    name: mouthAll[i],
                    isDisabled: false,
                    key: data[i].slice(0, -2),
                    isClick: false
                  })
                } else {
                  mouthData.push({
                    name: mouthAll[i],
                    isDisabled: true,
                    key: data[i],
                    isClick: true
                  })
                }
              }
              this.mouthData = mouthData
              this.isCheckMore()
              let tempChooseArr = this.tempChooseArr
              let selecedYear = this.selecedYear
              for (var v of tempChooseArr) {
                if (v.yearName == selecedYear) {
                  this.checkList = v.mouthArr
                }
              }
            })
      }
    },
    changeCheck(e) {
      let selecedYear = this.selecedYear
      let checkList = this.checkList
      let tempChooseArr = this.tempChooseArr
      if (tempChooseArr.length > 0) {
        var isPush = true
        for (var v of tempChooseArr) {
          if (v.yearName == selecedYear) {
            isPush = false
            v.mouthArr = checkList
          }
        }
        if (isPush) {
          tempChooseArr.push({yearName: selecedYear, mouthArr: checkList})
        }
      } else {
        if (checkList.length > 0) {
          tempChooseArr.push({yearName: selecedYear, mouthArr: checkList})
        }
      }
      this.tempChooseArr = tempChooseArr
      this.isCheckMore()
    },
    // 判断是否超过12个月
    isCheckMore() {
      let mouthData = this.mouthData
      let tempChooseArr = this.tempChooseArr
      let selecedYear = this.selecedYear
      var lens = 0
      if (tempChooseArr.length > 0) {
        for (var v of tempChooseArr) {
          lens += v.mouthArr.length
        }
      }
      if (lens >= 12) {
        // this.$message({
        //   message: '一次最多导出十二个月',
        //   type: 'warning'
        // });
        for (var v of mouthData) {
          for (var k of tempChooseArr) {
            if (k.yearName == selecedYear) {
              let mouthArr = k.mouthArr
              if (mouthArr.indexOf(v.key) != -1) {
                v.isDisabled = false
              } else {
                v.isDisabled = true
              }
            }
          }
        }
      } else {
        let mouthData = this.mouthData
        for (var v of mouthData) {
          if (v.isClick) {
            v.isDisabled = true
          } else {
            v.isDisabled = false
          }
        }
      }
    },
    // 上一年下一年
    preYear() {
      let selecedYear = this.selecedYear
      if (selecedYear > 0) {
        this.selecedYear = selecedYear - 1
        this.initMonthData()
      }
    },
    nextYear() {
      let selecedYear = this.selecedYear
      this.selecedYear = selecedYear + 1
      this.initMonthData()
    }
  }
}
</script>
